import React, { Fragment } from 'react'
import NavBarV2 from '../Navbar/NavbarV2'
import NavBarV3 from '../Navbar/NavbarV3'
import NavBarV4 from '../Navbar/NavbarV4'
import GlassBox from '../GlassBox'
import AdminTools from './AdminTools'
import SubHeaderContainer from '../../containers/SubHeader/SubHeader'

const HeaderExternal = ({
  allowCustomerOverride,
  location,
  language,
  header,
  toggleSearchModal,
  query,
  customer,
  devices,
  currentDevice,
  modulesAvailable,
  toggleDeviceModal,
  clearDevice,
  getOption,
  topLinks,
  version
}) => {
  return (
    <Fragment>
      {allowCustomerOverride && <AdminTools location={location} />}
      {version === 'v2' ? (
        <NavBarV2
          header={header}
          topLinks={topLinks}
          toggleSearchModal={toggleSearchModal}
          language={language}
          version={version}
        />
      ) : version === 'v3' ? (
        <NavBarV3
          header={header}
          toggleSearchModal={toggleSearchModal}
          language={language}
          topLinks={topLinks}
          version={version}
        />
      ) : (
        <>
          <GlassBox version={version} />
          <NavBarV4
            header={header}
            toggleSearchModal={toggleSearchModal}
            language={language}
            topLinks={topLinks}
            version={version}
          />
        </>
      )}
      <SubHeaderContainer
        toggleSearchModal={toggleSearchModal}
        devices={devices}
        getOption={getOption}
        language={language}
        currentDevice={currentDevice}
        clearDevice={clearDevice}
        toggleDeviceModal={toggleDeviceModal}
        query={query}
        modulesAvailable={modulesAvailable}
        externalNavEnabled={false}
        customer={customer}
      />
    </Fragment>
  )
}

export default HeaderExternal



// WEBPACK FOOTER //
// ./src/components/Header/HeaderExternal.js